var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97026 0C3.67813 0 3.4006 0.127748 3.21061 0.349671L0 4.1H24.2L20.8079 0.331034C20.6182 0.120321 20.3481 0 20.0646 0H3.97026ZM5.1986 0.600004C4.88596 0.600004 4.59132 0.746222 4.40223 0.9952L2.49996 3.5H12H21.5L19.544 0.985943C19.3545 0.742428 19.0632 0.600004 18.7547 0.600004H5.1986Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.1001H24.2V18.7001C24.2 19.8047 23.3046 20.7001 22.2 20.7001H2C0.895429 20.7001 0 19.8047 0 18.7001V4.1001ZM12.7871 16.8963C12.3908 17.3285 11.7094 17.3285 11.3131 16.8963L7.74113 13.001C7.15302 12.3596 7.60799 11.3251 8.47817 11.3251H9.80002V8.20012C9.80002 7.64784 10.2477 7.20012 10.8 7.20012H13.3C13.8523 7.20012 14.3 7.64784 14.3 8.20012V11.3251H15.622C16.4922 11.3251 16.9472 12.3596 16.3591 13.001L12.7871 16.8963Z",
    fill: "#1E1E1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 0.3,
    rx: 0.15,
    fill: "#3AB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.18d038bf4790e28f4001913cb8d9d02d.svg";
export { ForwardRef as ReactComponent };